export default __webpack_public_path__ + "locales/sq-AL/Notifications.json?hash=28c2843d9216baf20fed3dbda66e860f";